import { render, staticRenderFns } from "./Qualidade8.vue?vue&type=template&id=53b32c39&scoped=true&"
import script from "./Qualidade8.vue?vue&type=script&lang=js&"
export * from "./Qualidade8.vue?vue&type=script&lang=js&"
import style0 from "./Qualidade8.vue?vue&type=style&index=0&id=53b32c39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b32c39",
  null
  
)

export default component.exports